import { Injectable } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginStateResourceToLoginStateMapper } from '@models/mappers/login-state-resource-to-login-state.mapper';
import { LoginStateResource } from '@models/resource/login-state.resource';
import { LoginState } from '@models/ui/login-state.model';
import { CaseAnalyticsState } from '@models/ui/case-analytics-state/case-analytics-state.model';
import { CaseAnalyticsStateResource } from '@models/resource/case-analytics-state/case-analytics-state.resource';
import { CaseAnalyticsStateResourceToCaseAnalyticsStateMapper } from '@models/mappers/case-analytics-state-resource-to-case-analytics-state.mapper';

@Injectable({
	providedIn: 'root'
})
export class StateSdk extends SdkBase {
	public getLoginState(): Observable<LoginState> {
		return this.makeHttpRequest<LoginStateResource>('get', 'api2/state/login').pipe(
			map((response) => {
				const mapper = new LoginStateResourceToLoginStateMapper();
				return mapper.map(response);
			})
		)
	}

	public getCaseAnalyticsState(): Observable<CaseAnalyticsState> {
		return this.makeHttpRequest<CaseAnalyticsStateResource>('get', 'api2/state/case/analytics').pipe(
			map((response) => {
				const mapper = new CaseAnalyticsStateResourceToCaseAnalyticsStateMapper();
				return mapper.map(response);
			})
		)
	}
}


